import { render, staticRenderFns } from "./milestone-plan-confirmation-dialog.vue?vue&type=template&id=5db97f9e&scoped=true&"
import script from "./milestone-plan-confirmation-dialog.vue?vue&type=script&lang=ts&"
export * from "./milestone-plan-confirmation-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-plan-confirmation-dialog.vue?vue&type=style&index=0&id=5db97f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db97f9e",
  null
  
)

export default component.exports